module.exports = __webpack_public_path__ + "static/media/clouds-cover-final.4f58a37a.png";